import {Component, Input, OnInit} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-waiting',
  templateUrl: './waiting.component.html',
  styleUrls: ['./waiting.component.scss']
})
export class WaitingComponent implements OnInit{
  @Input()
  public message: string = '';
  @Input()
  public visible: boolean = false;

  constructor(){

  }
  
  ngOnInit() { }

}
